import { render } from "./MiBtn.vue?vue&type=template&id=00ca5772"
import script from "./MiBtn.vue?vue&type=script&lang=js"
export * from "./MiBtn.vue?vue&type=script&lang=js"

import "./MiBtn.vue?vue&type=style&index=0&id=00ca5772&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
